import { useState } from "react";

const Switch = ({ handleCheck, uuid, value }) => {

  const [check, _setCheck] = useState(value);

  const setCheck = (check) => {
    _setCheck(check);
    handleCheck(check, uuid);
  }

  return (<div class="bf-switch">
    <input type="checkbox" checked={check} class="checkbox" onChange={(event) => setCheck(event.target.checked)} />
    <div class="knobs">
      <span></span>
    </div>
    <div class="layer"></div>
  </div>);

}


export default Switch;